export enum STEPS {
  valid,
  expired,
  used,
}
